import {Base} from "@/api/Base"

export class PlanList extends Base {
    path = "plan/list"
}